import { FilterValue, InputComponentProps } from "./Filters";
import { Display_Value_Key as dvk } from "../Create/utils";
import { useEffect, useState } from "react";

// Text input component
const RenderViewsInput: React.FC<InputComponentProps> = ({
  filter,
  onChange,
  preSelected,
  onApplyStateChange,
}) => {
  const [comparison, setComparison] = useState<string>(">=");
  const [viewCount, setViewCount] = useState<string>("");
  const [input, setInput] = useState<number>(0);

  const handleEnterValueChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setViewCount(value);
  };

  const handleFitlerChange = () => {
    if (comparison == ">=") {
      onChange(filter.name, { gt: input }, `${comparison} ${input}`);
    } else {
      onChange(filter.name, { lt: input }, `${comparison} ${input}`);
    }
  };

  useEffect(() => {
    const numericValue = Number(viewCount);
    setInput(isNaN(numericValue) ? 0 : numericValue);
  }, [viewCount]);

  useEffect(() => {
    if (preSelected[filter.name + dvk]) {
      const [greaterOrsmaller, views] =
        preSelected[filter.name + "d"].split(" ");
      setComparison(greaterOrsmaller);
      setViewCount(views);
      setInput(views);
    }
  }, []);

  // Update apply state whenever input changes
  useEffect(() => {
    if (onApplyStateChange) {
      onApplyStateChange(!input, handleFitlerChange, "Apply");
    }
  }, [input, onApplyStateChange]);

  return (
    <div className="px-3">
      <p className="">{filter.suffix}</p>
      <div className="mb-3 py-3 border-bottom">
        <select
          className="form-select border-0 border-bottom border-dark rounded-0 shadow-none"
          value={comparison}
          onChange={(e) => setComparison(e.target.value)}
        >
          <option value=">=">{`>=`}</option>
          <option value="<=">{`<=`}</option>
        </select>
        <input
          type="text"
          className="form-control border-0 border-bottom border-dark rounded-0 shadow-none"
          value={viewCount}
          placeholder="Value"
          onChange={(e) => handleEnterValueChange(e)}
        />
      </div>

      <hr className="w-100 my-2 divider-line" />

      {/* <div className="d-flex justify-content-end">
        <button className="btn btn-primary btn-sm text-white" disabled={!input} onClick={handleFitlerChange}>
          APPLY
        </button>
      </div> */}
    </div>
  );
};

export default RenderViewsInput;
